// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fW","homeTitle_styleDefault":"c-a_fX","homeTitle_styleRed":"c-a_fY"};